import React from 'react';
import Icon from '../../../components/AppIcon';

const PlayCard = ({ play, onSelect, getDifficultyBadgeColor }) => {
  return (
    <div
      onClick={() => onSelect(play?.id)}
      className="group bg-surface-lighter border border-border rounded-xl overflow-hidden hover:border-accent-purple transition-all duration-300 cursor-pointer hover:shadow-xl hover:shadow-accent-purple/20 hover:-translate-y-1"
    >
      {/* Play Cover Image */}
      <div className="relative h-48 overflow-hidden bg-gradient-to-br from-accent-purple/20 to-accent-blue/20">
        {play?.cover_image_url ? (
          <img
            src={play?.cover_image_url}
            alt={`${play?.title} cover image showing the play's theatrical poster or relevant artwork`}
            className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-300"
          />
        ) : (
          <div className="w-full h-full flex items-center justify-center">
            <Icon name="BookOpen" size={64} className="text-accent-purple/50" />
          </div>
        )}
        
        {/* Difficulty Badge */}
        <div className="absolute top-3 right-3">
          <span className={`px-3 py-1 rounded-full text-xs font-semibold border ${getDifficultyBadgeColor(play?.difficulty)} backdrop-blur-sm capitalize`}>
            {play?.difficulty || 'medium'}
          </span>
        </div>
      </div>

      {/* Play Info */}
      <div className="p-5">
        <h3 className="text-xl font-bold text-white mb-1 group-hover:text-accent-purple transition-colors">
          {play?.title}
        </h3>
        <p className="text-text-secondary text-sm mb-3 flex items-center gap-2">
          <Icon name="User" size={14} />
          {play?.author}
        </p>
        
        <p className="text-text-secondary text-sm mb-4 line-clamp-2">
          {play?.description}
        </p>

        {/* Stats Row */}
        <div className="flex items-center justify-between text-xs text-text-secondary border-t border-border pt-3">
          <div className="flex items-center gap-1">
            <Icon name="FileText" size={14} />
            <span>{play?.total_scenes || 0} scenes</span>
          </div>
          <div className="flex items-center gap-1">
            <Icon name="MessageSquare" size={14} />
            <span>{play?.total_lines || 0} lines</span>
          </div>
          <div className="flex items-center gap-1">
            <Icon name="Calendar" size={14} />
            <span>{play?.year_written || 'N/A'}</span>
          </div>
        </div>

        {/* Read Button */}
        <button className="w-full mt-4 btn-primary py-2 text-sm group-hover:bg-accent-purple/90">
          <span className="flex items-center justify-center gap-2">
            Start Reading
            <Icon name="ArrowRight" size={16} />
          </span>
        </button>
      </div>
    </div>
  );
};

export default PlayCard;